import React from 'react';
import ProgramStatusCard from './components/ProgramStatusIndex.jsx';

const ProgramStatus = () => <ProgramStatusCard />;

export default ProgramStatus;
